import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { Container, Button } from 'semantic-ui-react';
import SplashCards from "./SplashCards";

export default class Hero extends Component {

    // updateStateAuth = () => window.location = "/login";

    render() {

        return (
            <Container>
                <div className='hooli-hero-content'>
                    <div className='hooli-text-white hooli-font-large'>Manage your money like never before</div>
                    <div className='hooli-text-white hooli-font-light'>
                        We empower you to feel more comfortable with you financial situation by consolidating all your accounts into one place.
                    </div>
                    <div className='hooli-btn-group'>
                        <Link to='/account-select'>
                            <Button className='hooli-btn-primary'>Get Started for Free</Button>
                        </Link>
                        <Button inverted>Learn More</Button>
                    </div>
                </div>

                <SplashCards />
            </Container>
        )

    }

}
